// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"3450dbb0","498":"1582e364","703":"d9c5182f"}[chunkId] + ".chunk.js";
};